import api from './api';
import types from './mutation-types';

export default {
	defaultAssign_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, {
			key,
			value
		});
	},
	getPlant_({ commit }) {
		return api
			.getPlant()
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_OPTION_PLANT_LIST, {
						key: 'tableDataPlants',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},
	getCommCds_({ commit }, params = { commCdType, commCdList, option }) {
		return api
			.getCommCds(params)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_OPTION_LIST, {
						key: 'tableTypes',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	//공통 코드 조회: 사용 유무
	getUseYnList_({ commit, rootState, rootGetters }) {
		return api
			.getCommCds({ plantCd: rootState.commonStore.user.plantCd, commCdType: 'USE_YN' }) //USE_YN 공통 API 조회
			.then(res => {
				if (res.header.code === 0) {
					//API 응답이 정상일 경우
					// const getMessage_ = rootGetters['commonStore/getMessage_']; //전역 Store의 다국어 처리 getter 호출
					const value = res.body.map(({ commCd, commCdName }) => ({ label: commCdName, value: commCd })); //selectBox에서 사용할 label 다국어 처리
					value.unshift({ label: 'All', value: '' });
					commit(types.DEFAULT_ASSIGN, { key: 'useYnOptions', value }); //Select Box Options 값 Vuex에 저장
				}
				return res.header;
			})
			.catch(error => {
				throw error;
			});
	},

	getSchemas_({ commit }, { plantCd }) {
		return api
			.getSchemas({ plantCd: plantCd })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_SCHEMA_LIST, {
						key: 'schemas',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getAllSchemas_({ commit }, { plantCd }) {
		return api
			.getAllSchemas({ plantCd: plantCd })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_SCHEMA_LIST, {
						key: 'allSchemas',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	getUnmanagedTables_({ commit }, { plantCd, schema }) {
		return api
			.getUnmanagedTables({ plantCd, schema })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_UNMANAGED_TABLE_LIST, {
						key: 'unmanagedTables',
						list: data.body
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	setModalValue_({ commit }, { key, value }) {
		commit(types.SET_TABLE_MANAGEMENT_MODAL_VALUE, { key, value });
	},

	getTableDataManagementList_({ commit }, params = { plantCd, schema, tableId, managed, currentPage, pageUnit }) {
		return api
			.getTableDataManagementList(params)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.SET_SEARCH_PARAM, params);
					const { currentPage, pageUnit, totalSize } = data.body.pagingInfo;
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: { currentPage, pageUnit, totalSize, data: data.body.resultList }
					});
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	addTables_({ rootState }, { params }) {
		return api
			.addTables({ plantCd: rootState.commonStore.user.plantCd, params })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	saveTables_({ rootState }, { params }) {
		return api
			.saveTables({ plantCd: rootState.commonStore.user.plantCd, params })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	delTables_({ rootState }, { params }) {
		return api
			.delTables({ plantCd: rootState.commonStore.user.plantCd, params })
			.then(data => {
				if (data.header.code === 0) {
					return data.header;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},

	closeModal_({ commit }) {
		commit(types.DEFAULT_ASSIGN, {
			key: 'tableDataManagementModalValue',
			value: {
				flg: 'I',
				tableId: '',
				saveDays: '',
				delCycleDay: '',
				delCycleTime: ''
			}
		});

		commit(types.DEFAULT_ASSIGN, {
			key: 'TableDataManagementModal',
			value: false
		});
	},

	async mergePolicy_({ commit }, status) {
		let store = this.state.tableDataManagementStore;
		let result = await api.mergePolicy({
			plantCd: store.plant,
			tableId: store.modalValue.tableId,
			status: status,
			requestBody: store.modalValue
		});
		return result;
	},
	async deletePolicy_({ commit }) {
		let store = this.state.tableDataManagementStore;
		let result = await api.deletePolicy({
			plantCd: store.plant,
			tableId: store.modalValue.tableId
		});
		return result;
	}
};
